import { create } from 'zustand';

interface AudioState {
  isMuted: boolean;
  setMuted: (muted: boolean) => void;
  toggleMute: () => void;
}

export const useAudioStore = create<AudioState>((set) => ({
  isMuted: false,
  setMuted: (muted) => set({ isMuted: muted }),
  toggleMute: () => set((state) => ({ isMuted: !state.isMuted })),
}));
